<template>
  <v-app id="inspire">
  <div class="container"  v-if="deal.id && iso.id">
    <v-flex xs12 sm6 offset-sm3>
      <v-card >
        <v-card-title class="blue white--text">
          <span class="headline">Accept Offer and Request Contract Form</span>
            
          <flash-message class="myCustomClass" id="myCustomClass"></flash-message>
    
          <v-spacer></v-spacer>

        </v-card-title>
        <v-card-text v-if="formStatus === 0">
          <v-form onSubmit="return false;"  ref="form" lazy-validation>
                      <p>Position Number: {{offer.lender_position_number}}</p>
                      <p>Offer Amount: {{offer.lender_offer_amount | currency}}</p>
                      <p>Payback Amount: {{offer.lender_payback_amount | currency}}</p>
                      <p>Max Upsell: {{offer.lender_factor_rate}}</p>
                      
                      <!--Test-->
                      <v-flex class="pr-3">
                        <v-slider
                          v-model="slider"
                          :max="max"
                          :min="min"
                          :label="slider"
                          thumb-label="always"
                          prefix='%'
                         
                          v-on:change="calculatePayment"
                        ></v-slider>
                      </v-flex>
                      <!--Test-->
                      
                      <p>Buy Rate: {{offer.lender_buy_rate}}</p>
                      <p>Payment: {{offer.lender_payment | currency}} {{offer.lender_payment_type}} </p>
                      <p>Term: {{offer.lender_term}} Days</p>
                      <p >Note: <span v-html="offer.offer_notify_note"></span></p>
                  
                  <v-flex xs12 sm12 md12>
                    <p>Please attach Driver Lisense and Void Check to order contract:</p>
                    <div class="large-12 medium-12 small-12 filezone">
                      <input type="file" id="files" ref="files" multiple v-on:change="handleFiles()" />
                      <p>
                        Drop your files here <br>or click to search
                      </p>
                    </div>
          
                    <div v-for="(file, key) in files" class="file-listing " :key="key">
                        
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6>
                        <img class="preview" v-bind:ref="'preview'+parseInt(key)" height="70" width="100"/>
                        <p>{{file.fileUploaded.name}}</p>
                        
                        </v-flex>
                        
                        <v-flex xs12 sm6 md6>
                          <v-select
                            v-model="file.category_id"
                            :rules="[v => !!v || 'File Category is required']"
                            :items="categories"
                            item-text="file_category_name"
                            item-value="id"
                            label="File Category"
                            persistent-hint
                            required
                            autocomplete
                          ></v-select>
                        </v-flex>  
                      
                      </v-layout>
                        
                        <div class="success-container" v-if="file.id > 0">
                          Success
                        </div>
                        <div class="remove-container" v-else>
                          <a class="remove" v-on:click="removeFile(key)">Remove</a>
                        </div>
            
                    </div>
          
                  </v-flex>
                  <!--Files Upload-->
                  
                  <div class="col-md-12">
                      <vue-editor id="note" placeholder="How would you like to receive contracts? Send E-Sign directly to merchant(s) or Email as attachment?" v-model="iso_message" :editorToolbar="customToolbar"></vue-editor>
                  </div>
                  
                   <v-btn color="primary" @click="sendNotification" :disabled="progressModel">
                    Submit
                  </v-btn>
      
            </v-form>
          <!--<progress-model v-if="progressModel"></progress-model>-->
        </v-card-text>
        <v-card-text v-if="formStatus === 1">
          <p>Your contract request has been processed. We will get back to you shortly.</p>
          <br>
          <p>Thank you,</p>
          <!-- <v-btn color="primary" @click="logout">
              DONE
          </v-btn> -->
        </v-card-text>
      </v-card>
    </v-flex>
    
    
     <div class="text-xs-center">
    <v-dialog v-model="progressModel" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
      
</div>

</v-app>
</template>

<script>
	// Basic Use - Covers most scenarios
	import axios from 'axios';
  import {VueEditor} from 'vue2-editor';
  import {URL, config} from '../../env'

	export default {
    components: {
      VueEditor,
    },

    data() {
      return {
        formStatus: 0,
        min: 1,
        max: 0,
        slider: 0,
        isoInfo: {},
        progressModel: false,
        uploaded: false,
        categories: [],
        category_id: null,
        files: [],
        iso_message: '',
        image: '',
        uploadedFiles:'',
        offer: {},
        deal:{},
        iso:{},
        // Set Custom toolbar for vue editor
			customToolbar: [
				[{ header: [false, 1, 2, 3, 4, 5, 6] }],
				[{ size: ["small", "large", "huge"] }],
				["bold", "italic", "underline", "strike"],
				[
					{ align: "" },
					{ align: "center" },
					{ align: "right" },
					{ align: "justify" }
				],
				[{ header: 1 }, { header: 2 }],
				["blockquote", "code-block"],
				[{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
				[{ script: "sub" }, { script: "super" }],
				[{ indent: "-1" }, { indent: "+1" }],
				[{ color: [] }, { background: [] }],
				[{ direction: "rtl" }],
				["clean"]
			],
      }
    },

   mounted() {
     console.log('fksdhjkfhsdjkfs',this.$route.params.lender_id)
      axios.get(`${URL}/get_deal_for_iso/${this.$route.params.lender_id}/${this.$route.params.unique_id}`).then(res=>{
        this.deal = res.data.data.offer[0];
        this.offer = res.data.data.offer[0]
        this.iso = res.data.data.iso[0];
        this.max = this.deal.lender_commission_percentage;
        this.slider= this.deal.lender_commission_percentage

        axios.post(`${URL}/send_offer_accepted_email`, {deal: this.deal, iso: this.iso}).then(res=>{

        })  
      })
          
      //Get File Categories
      this.getCategories()
    },
    
    watch: {},
    
    methods: {
      
      getCategories () {
        axios.get(`${URL}/api/file_category/file_categories`).then((resp => {
          this.categories = resp.data.data;
          
        }));
      },

      logout() {
            this.$store.dispatch("userLogout").then(function(response) {
                //location.reload();
            });
        },
      
      //***************************************
      //Merchant Files Upload Functions
      
      handleFiles() {
        let uploadedFiles = this.$refs.files.files;

        for (var i = 0; i < uploadedFiles.length; i++) {
            
          this.files.push({fileUploaded: uploadedFiles[i], category_id: null});
        }
        this.getImagePreviews();
      },

      //handle image preview
      getImagePreviews() {
        for (let i = 0; i < this.files.length; i++) {
          if (/\.(jpe?g|png|gif)$/i.test(this.files[i].fileUploaded.name)) {
            let reader = new FileReader();
            reader.addEventListener("load", function() {
              this.$refs['preview' + parseInt(i)][0].src = reader.result;
            }.bind(this), false);
            reader.readAsDataURL(this.files[i].fileUploaded);
          }
          else {
            this.$nextTick(function() {
              this.$refs['preview' + parseInt(i)][0].src = 'https://www.foot.com/wp-content/uploads/2017/03/placeholder.gif';
            });
          }
        }
      },

      //Remove file
      removeFile(key) {
        this.files.splice(key, 1);
        this.getImagePreviews();
      },

      //Method to submit merchant files
      submitFiles: async function() {
          
        let vm = this;
        
        if(vm.files.length > 0){
        if (this.$refs.form.validate()) {
        
            for (let i = 0; i < vm.files.length; i++) {
              if (vm.files[i].fileUploaded.id) {
                continue;
              }
              let formData = new FormData();
              formData.append('file', vm.files[i].fileUploaded);
              formData.append('user_id', vm.isoInfo.id);
              formData.append('deal_id', vm.deal.deal_id);
              formData.append('file_category_id', vm.files[i].category_id);
              await axios.post('/api/deal_file/deal_files',
                formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                }
              ).then(function(data) {
                vm.files[i].id = data['data']['id'];
                vm.files.splice(i, 1, vm.files[i]);
                
                 if (data.data.success) {
                    
                    //Set Flash message
                    vm.flash(data.data.message, 'success', {
                        timeout: 4000,
                      });
                      
                      vm.uploaded = true;
                      
                  }
                
              }.bind(this)).catch(function(data) {
                
                 //Set Flash message
                     vm.flash('There was an error uploading files.', 'error', {
                        timeout: 4000,
                      });
                
              });
            }
            
            vm.files = [];
            vm.saveUpdateSubmission();
            
           // alert("Thank you your file has been uploaded. We will get back to your shortly")
           // location.reload();
        }
      }else{
        vm.saveUpdateSubmission();
      }

      },

      //Merchant Files Upload Functions END
      //***************************************
      
      //Save Form
    saveOfferUpdate () {
        let app = this;
            
                  axios.put('/api/deal_lender/deal_lenders/' + app.deal.id, {
                  //_token: window.Laravel.csrfToken,
                  deal_id: this.deal.deal_id,
                  lender_offer_status: 'Offer Accepted',
                  lender_offer_amount: app.offer.lender_offer_amount,
                  lender_payback_amount: app.offer.lender_payback_amount,
                  lender_payment: app.offer.lender_payment,
                  lender_factor_rate: app.offer.lender_factor_rate,
                  lender_buy_rate: app.offer.lender_buy_rate,
                  lender_commission_percentage: app.slider,
                  lender_term: app.offer.lender_term,
                }).then(function(response) {
                 if (response.data.success) {
                    
                    app.flash(response.data.message, 'success', {
                      timeout: 3000,
                    });
                    
                    app.submitFiles();
                }
                }).catch(function(error) {
                  //Set Flash message
                  app.flash('There was an error', 'error', {
                        timeout: 3000,
                  });
                });
                axios.put('/api/submission/submissions/' + app.deal.deal_id, {
                 // _token: window.Laravel.csrfToken,
                  deal_status: 'Request Price Adjustment',
                  deal_next_processor_role: 'Credit Analyst',
                }).then(function(response) {
                 if (response.data.success) {
                    
                    // app.flash(response.data.message, 'success', {
                    //   timeout: 3000,
                    // });
                    
                    // app.submitFiles();
                }
                }).catch(function(error) {
                  //Set Flash message
                  app.flash('There was an error', 'error', {
                        timeout: 3000,
                  });
                });
      },
      
       sendNotification () {
            let vm = this;
            
            vm.progressModel = true;
                        
            axios.post('/iso_accept_offer_noti', {
                    //"_token": window.Laravel.csrfToken,
                    deal_id: vm.deal.deal_id,
                    deal_lender_id: vm.deal.id,
                    iso_message: vm.iso_message,
                })
                .then(function(response) {
                    
                    if (response.data.success) {
                      
                     }    
                  
                }).catch(function(error) {
                    
                })
                vm.saveNote();
        },
        
     //Save Form
    saveNote () {
        let app = this;
            
              axios.post('/api/submission_note/submission_notes', {
                  //_token: window.Laravel.csrfToken,
                  deal_id: app.deal.deal_id,
                  user_id: app.isoInfo.id,
                  deal_user_note: app.iso_message,
                  deal_note_type: "Offer",
                  pinned: false,
                }).then(function(response) {
                  
                   if (response.data.success) {
                      
                    }
                    
                    app.saveActivity();
                    
                }).catch(function(error) {
                  //Set Flash message
                  app.flash('Error Adding Note', 'error', {
                      timeout: 3000,
                  });
                })
            
      },
        
    //Save Form
    saveActivity () {
        let app = this;
            
              axios.post('/api/submission_note/submission_notes', {
                  //_token: window.Laravel.csrfToken,
                  deal_id: app.deal.deal_id,
                  user_id: app.isoInfo.id,
                  deal_user_note:'Offer Accepted',
                  deal_note_processor_role: app.isoInfo.role,
                  deal_note_type: "Activity",
                  pinned: false,
                }).then(function(response) {
                  
                   if (response.data.success) {
                      
                    }
                    
                    app.saveOfferUpdate();
                    
                }).catch(function(error) {
                  //Set Flash message
                  app.flash('Error Adding Note', 'error', {
                      timeout: 3000,
                  });
                })
            
      },
      
      //Save Form
    async saveUpdateSubmission () {
      try {
        const resp = await this.$store.dispatch(
          "deals/submissions/updateStatus",
          {
            id: this.deal.deal_id,
            user_id: 0,
            deal_status: 'Contract Request'
          }
        );
        if (resp) {
          this.progressModel = false;
          this.formStatus = 1;
          this.logout();
          this.flash(resp.data.message, "success", {
            timeout: 3000
          });
        }
      } catch (error) {
        this.flash(resp.data.message, "error", {
          timeout: 3000
        });
      }
    },
      
      calculatePayment(){
        let app = this;
        
        if(app.offer.lender_factor_rate.length > 0){
          
          let commission_percentage = (app.slider / 100).toFixed(2);
        
          let factor_rate = (+app.offer.lender_buy_rate + +commission_percentage).toFixed(2);
          app.offer.lender_factor_rate = factor_rate;
            
          let payback_amount = factor_rate * app.offer.lender_offer_amount;
            app.offer.lender_payback_amount = payback_amount;
            
          if(app.deal.lender_payment_type.toUpperCase() == 'DAILY'){ 
            
            app.offer.lender_payment = (payback_amount / app.offer.lender_term).toFixed(2);
    
          }else if(this.deal.lender_payment_type.toUpperCase() == 'WEEKLY'){
        
            app.offer.lender_payment = (payback_amount / app.offer.lender_term * 5).toFixed(2);
            
          }
          
        }
        
        
      }, 

    }

  }
</script>


<style scoped>
  input[type="file"] {
    opacity: 0;
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

  .filezone {
    outline: 2px dashed #2196F3;
    outline-offset: -10px;
    /*background: #ccc;*/
    background: #FAFAFA;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px;
    position: relative;
    cursor: pointer;
  }

  .filezone:hover {
    background: #EEEEEE;
  }

  .filezone p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 50px 50px 50px;
  }

  div.file-listing img {
    max-width: 90%;
  }

  div.file-listing {
    margin: auto;
    padding: 10px;
    border-bottom: 1px solid #ddd;
  }

  div.file-listing img {
    height: 100px;
  }

  div.success-container {
    text-align: center;
    color: green;
  }

  div.remove-container {
    text-align: center;
  }

  div.remove-container a {
    color: red;
    cursor: pointer;
  }

  a.submit-button {
    display: block;
    margin: auto;
    text-align: center;
    width: 200px;
    padding: 10px;
    text-transform: uppercase;
    background-color: #CCC;
    color: white;
    font-weight: bold;
    margin-top: 20px;
  }
</style>


<style scoped>
  .fileUpload {
    position: relative;
    overflow: hidden;
    margin: 25px;
  }

  .fileUpload input.upload {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0;
    padding: 0;
    font-size: 20px;
    cursor: pointer;
    opacity: 0;
    filter: alpha(opacity=0);
  }
</style>
